import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import {
  CssBaseline, CircularProgress, Container, Button, Grid, Box, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  IconButton, Collapse, Typography, Card, CardContent, Accordion,
  AccordionSummary, AccordionDetails, TextField, Chip
} from "@mui/material"
import { withStyles } from "@mui/styles"
import Pagination from '@mui/material/Pagination'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import moment from "moment"
import { injectIntl } from 'react-intl'
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import Footer from '../../components/footer'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import SimpleAutoCompleteSearch from '../../components/auto-complete/autocomplete-search-api'
import Api from "../../services/api"
import ApiReports from "../../services/apireport"
import ScheduleReportButton from "../../components/report-schedule";
import * as calledsActions from '../../redux/actions/calleds'

const OUTCOME_LABELS = {
  accepted: { label: 'Aceita', bg: '#dcfce7', color: '#166534' },
  edited: { label: 'Editada', bg: '#dbeafe', color: '#1e40af' },
  discarded: { label: 'Descartada', bg: '#fee2e2', color: '#991b1b' },
  generated: { label: 'Gerada', bg: '#f1f5f9', color: '#475569' }
}

class AISuggestionReport extends Component {
  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false
    this.isAdmGlobal = false

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
      if (item.role.roletype == 0)
        this.isAdmGlobal = true
    })

    this.state = {
      dateStart: moment().subtract(1, 'months').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      calledIdFilter: '',
      userFilter: 0,
      organizationFilter: 0,

      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,

      suggestionList: [],
      expandedRows: {},

      organizationList: [],

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0
    }

    this.changeValues = this.changeValues.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await this.getOrganizations()
    this.setState({ loading: false })
  }

  getOrganizations = async () => {
    await Api.get('/organizations/list')
      .then(result => {
        if (result.data.success)
          this.setState({ organizationList: result.data.data })
      })
      .catch(() => {})
  }

  changeValues = async (stateName, value) => {
    if (value && value.id !== undefined) {
      this.setState({ [stateName]: value.id })
    } else {
      this.setState({ [stateName]: value })
    }
  }

  clearFilters = () => {
    this.setState({
      dateStart: moment().subtract(1, 'months').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      calledIdFilter: '',
      userFilter: 0,
      organizationFilter: 0,
      showGrid: false,
      suggestionList: [],
      expandedRows: {},
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0
    })
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    await this.fetchReport()
  }

  buildFilterParams = (dateStart, dateEnd) => {
    let params = `startDate=${dateStart}&endDate=${dateEnd}`

    if (this.state.calledIdFilter && this.state.calledIdFilter.trim() !== '')
      params += `&calledId=${this.state.calledIdFilter.trim()}`

    if (this.state.userFilter && this.state.userFilter !== 0)
      params += `&userId=${this.state.userFilter}`

    if (this.state.organizationFilter && this.state.organizationFilter !== 0)
      params += `&organizationId=${this.state.organizationFilter}`

    return params
  }

  fetchReport = async () => {
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (moment(dateStart).isAfter(moment(dateEnd))) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: "A data inicial deve ser menor que a data final.",
        loading: false
      })
      return
    }

    await this.fetchPaginate(dateStart, dateEnd, 1)

    this.setState({ showGrid: true, loading: false, scheduleRequest: `/report/ai-suggestion/paginate?${this.buildFilterParams(dateStart, dateEnd)}` }) // Agendamento de relatórios
  }

  fetchPaginate = async (dateStart, dateEnd, page) => {
    const params = this.buildFilterParams(dateStart, dateEnd)

    await ApiReports.get(`/report/ai-suggestion/paginate?${params}&page=${page}&pageSize=10`)
      .then(result => {
        if (result.data.success) {
          this.setState({
            suggestionList: result.data.data,
            count: result.data.count,
            page
          })
          this.setPagination(result.data.count, page)
        }
      })
      .catch(err => {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors
            ? err.response.data.errors[0]
            : "Erro ao buscar relatório de sugestões de IA."
        })
      })
  }

  onChangePaginate = (e, page) => {
    this.setState({ loading: true })
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
    this.fetchPaginate(dateStart, dateEnd, page).then(() => {
      this.setState({ loading: false })
    })
  }

  setPagination = (count, page) => {
    const totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        this.setState({
          pageStart: 1,
          pageEnd: count < 10 ? count : 10
        })
      } else {
        const pageStart = ((page - 1) * 10) + 1
        this.setState({
          pageStart,
          pageEnd: count >= page * 10 ? page * 10 : count
        })
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0, pageStart: 0, pageEnd: 0 })
    }
  }

  toggleRow = (rowKey) => {
    this.setState(prev => ({
      expandedRows: { ...prev.expandedRows, [rowKey]: !prev.expandedRows[rowKey] }
    }))
  }

  closeNotification = () => {
    this.setState({ openNotification: false })
  }

  exportExcel = async () => {
    this.setState({ loading: true })
    try {
      const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
      const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

      if (moment(dateStart).isAfter(moment(dateEnd))) {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: "A data inicial deve ser menor que a data final.",
          loading: false
        })
        return
      }

      let calledId = null
      if (this.state.calledIdFilter && this.state.calledIdFilter.trim() !== '') {
        const parsedCalledId = Number(this.state.calledIdFilter.trim())
        if (Number.isNaN(parsedCalledId) || parsedCalledId <= 0) {
          this.setState({
            openNotification: true,
            notificationVariant: "error",
            notificationMessage: "Informe um Id Chamado valido.",
            loading: false
          })
          return
        }
        calledId = parsedCalledId
      }

      const payload = {
        DateStart: dateStart,
        DateEnd: dateEnd,
        CalledId: calledId,
        UserId: this.state.userFilter && this.state.userFilter !== 0 ? this.state.userFilter : null,
        OrganizationId: this.state.organizationFilter && this.state.organizationFilter !== 0 ? this.state.organizationFilter : null
      }

      const aiSuggestionExportEndpoint = '/report/ai-suggestion/excell/new'
      const response = await ApiReports.post(aiSuggestionExportEndpoint, payload)
      if (response.data && response.data.success) {
        this.setState({
          openNotification: true,
          notificationVariant: "success",
          notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")"
        })
      } else {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: response && response.data && response.data.errors && response.data.errors[0]
            ? response.data.errors[0]
            : this.props.intl.formatMessage({ id: "process.error" })
        })
      }
    } catch (error) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: error && error.response && error.response.data && error.response.data.errors && error.response.data.errors[0]
          ? error.response.data.errors[0]
          : this.props.intl.formatMessage({ id: "process.error" })
      })
    }
    this.setState({ loading: false })
  }

  renderMainTable() {
    const { suggestionList } = this.state

    return (
      <Paper elevation={2} style={{ borderRadius: 12, overflow: 'hidden', marginBottom: 20 }}>
        <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
            Sugestões de IA geradas
          </Typography>
          <Typography variant="caption" style={{ opacity: 0.8, color: 'inherit' }}>
            {this.state.count} registro(s)
          </Typography>
        </Box>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow style={{ backgroundColor: '#3F51B4' }}>
                <TableCell style={{ fontWeight: 700, width: 30, color: '#fff' }} />
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Data</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Origem</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Chamado</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Organização</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Usuário</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Modelo</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Qtd. Sugestões</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {suggestionList.map((item, idx) => {
                const rowKey = `${item.calledid || 'c0'}-${item.chatid || 'h0'}-${item.userid}-${item.contexthash}-${idx}`
                const suggestions = item.suggestions || []
                return (
                  <React.Fragment key={rowKey}>
                    <TableRow hover style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                      <TableCell>
                        <IconButton size="small" onClick={() => this.toggleRow(rowKey)}>
                          {this.state.expandedRows[rowKey] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                      </TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap' }}>
                        {item.generatedat ? moment(item.generatedat).format('DD/MM/YYYY HH:mm:ss') : '-'}
                      </TableCell>
                      <TableCell>
                        <Chip size="small" label={item.origin === 'accompaniment' ? 'Chamado' : 'Chat'} style={{ backgroundColor: '#e0e7ff', color: '#3730a3', fontWeight: 600 }} />
                      </TableCell>
                      <TableCell style={{ maxWidth: 220 }}>
                        <Typography style={{ fontSize: 12, color: '#475569' }} noWrap>
                          {item.calledid ? `#${item.calledid} - ${item.calledtitle || ''}` : '-'}
                        </Typography>
                      </TableCell>
                      <TableCell>{item.organizationname || '-'}</TableCell>
                      <TableCell>{item.username || '-'}</TableCell>
                      <TableCell>{item.llmname || '-'}</TableCell>
                      <TableCell align="center">{suggestions.length}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: this.state.expandedRows[rowKey] ? undefined : 'none' }} colSpan={8}>
                        <Collapse in={this.state.expandedRows[rowKey]} timeout="auto" unmountOnExit>
                          <Box style={{ margin: '12px 0', padding: 16, backgroundColor: '#f8fafc', borderRadius: 8 }}>
                            <Grid container spacing={2}>
                              {suggestions.map((suggestion) => {
                                const outcome = OUTCOME_LABELS[suggestion.outcome] || OUTCOME_LABELS.generated
                                const showFinal = suggestion.finalcontent && suggestion.finalcontent !== suggestion.content
                                return (
                                  <Grid item xs={12} key={suggestion.id}>
                                    <Box style={{ padding: 12, backgroundColor: '#fff', borderRadius: 8, border: '1px solid #e2e8f0', marginBottom: 8 }}>
                                      <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>
                                          Sugestão {suggestion.suggestionindex + 1}
                                        </Typography>
                                        <Chip size="small" label={outcome.label} style={{ backgroundColor: outcome.bg, color: outcome.color, fontWeight: 600 }} />
                                      </Box>
                                      <Typography style={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>
                                        {suggestion.content || '-'}
                                      </Typography>
                                      {showFinal && (
                                        <>
                                          <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, marginTop: 8, display: 'block' }}>
                                            Texto final utilizado
                                          </Typography>
                                          <Typography style={{ fontSize: 13, whiteSpace: 'pre-wrap', color: '#1e40af' }}>
                                            {suggestion.finalcontent}
                                          </Typography>
                                        </>
                                      )}
                                    </Box>
                                  </Grid>
                                )
                              })}
                            </Grid>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                )
              })}
              {suggestionList.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} align="center" style={{ padding: 40, color: '#94a3b8' }}>
                    Nenhuma sugestão de IA encontrada no periodo informado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    )
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props

    if (!this.isAdmGlobal) {
      const l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    if (Api == null) {
      const l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      Relatório de Sugestões de IA
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <form name='aiSuggestionReportForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>Filtros</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container style={{ marginBottom: 20 }} spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker
                        label="Data Inicial"
                        name='dateStart'
                        stateName='dateStart'
                        changeDate={this.changeValues}
                        currentDate={this.state.dateStart}
                        fullWidth={true}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker
                        label="Data Final"
                        name='dateEnd'
                        stateName='dateEnd'
                        changeDate={this.changeValues}
                        currentDate={this.state.dateEnd}
                        fullWidth={true}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        label="Id Chamado"
                        value={this.state.calledIdFilter}
                        onChange={(e) => this.changeValues('calledIdFilter', e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="medium"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoCompleteSearch
                        label="Usuário"
                        options={[]}
                        stateName='userFilter'
                        changeSelect={this.changeValues}
                        urlapi={Api.apiurlbase() + 'api/users/search/user'}
                        style={{ width: '100%' }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box sx={{ '& .MuiAutocomplete-root': { width: '100%' } }}>
                        <SimpleAutoComplete
                          label="Organização"
                          options={this.state.organizationList}
                          stateName='organizationFilter'
                          changeSelect={this.changeValues}
                          selected={this.state.organizationList.find(item => item.id === this.state.organizationFilter) || { id: 0, name: '' }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Grid container style={{ marginBottom: 10 }}>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button type='submit' fullWidth variant='contained' color='secondary'>
                    Filtrar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button fullWidth variant='contained' color='secondary' onClick={this.clearFilters}>
                    Limpar filtros
                  </Button>
                </Grid>
                {this.state.showGrid && (
                  <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                    <Button fullWidth variant='contained' color='secondary' onClick={this.exportExcel}>
                      Exportar Excel
                    </Button>
                  </Grid>
                )}
{this.state.showGrid && this.state.scheduleRequest && <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
  <ScheduleReportButton reportKey="ai-suggestion" request={this.state.scheduleRequest} color="secondary" />
</Grid>}
              </Grid>
            </form>

            {this.state.showGrid && (
              <>
                <Box style={{ marginTop: 32 }}>
                  {this.renderMainTable()}
                </Box>

                <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                  <Grid item xs={12} md={3}>
                    <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {this.state.pageStart} a {this.state.pageEnd} de {this.state.count} registro(s)
                  </Grid>
                </Grid>
              </>
            )}

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

AISuggestionReport.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AISuggestionReport)))
